import { Slider } from "antd";
import styled from "styled-components";

import color from "../_style/color";

export default styled(Slider)`
  width: calc(100% - 14px);

  .ant-slider-rail {
    display: none;
  }

  .ant-slider-handle {
    border: solid 2px ${color.primary};
  }

  :hover .ant-slider-handle,
  .ant-slider-handle:hover {
    border-color: ${color.veryLightGrey} !important;
  }

  .ant-slider-track {
    height: 1px;
    background-color: ${color.primary};
  }

  :hover .ant-slider-track {
    background-color: ${color.primary};
  }
`;
